module.exports = __webpack_public_path__ + "static/media/Chimecho_gaussian2.c9a41f58.png";